export default __webpack_public_path__ + "static/media/GO_YELLOW.3709e182.png";